import { Container, SectionFull, Link, ServiceTile } from "components"
import useTranslate from "logic/hooks/use-translate"
import React from "react"
import styled from "styled-components"
import tw from "twin.macro"
import useTilesStagger, {
  TilesStaggerVars,
} from "logic/hooks/use-tiles-stagger"
import { ServiceOrderItemType } from "model/content"

import { AnchorToGoTo } from "components/AnchorToGoTo"
import Title from "./Title"

const StyledServicesSection = styled(SectionFull)`
  ${tw``}
`

const ServicesContent = styled.div`
  ${tw`relative py-16 lg:py-24 md:w-11/12 z-20`}
`

const TileList = styled.ul`
  ${tw`grid md:grid-cols-2 xl:grid-cols-3 gap-8 md:gap-0 p-px pb-0`};
`
const TileContainer = styled.li`
  ${tw`relative -mr-px z-10`};
`

const staggerOptions: TilesStaggerVars = {
  stagger: { from: "random" },
  slideInOnMobile: true,
}

interface ServicesSectionProps {
  items: ServiceOrderItemType[] | undefined
}

const ServicesSection: React.FC<ServicesSectionProps> = ({ items }) => {
  const { SERVICES } = useTranslate(["SERVICES"])
  const { sectionRef, tilesRefs } = useTilesStagger(false, staggerOptions)

  return !items || items.length === 0 ? null : (
    <StyledServicesSection>
      <AnchorToGoTo id="services" />
      {/* <Container>
        <ServicesContent>
          <Title title={SERVICES} />
        </ServicesContent>
      </Container> */}
      <TileList ref={sectionRef}>
        {items.map((service, i) => (
          <TileContainer key={service.title}>
            {/* <Link
              to={service.slug ? `/services/${service.slug}/` : `/rentals/`}
            > */}
            <ServiceTile
              heading={service.heading}
              title={service.title}
              image={{ fluid: service.image.fluid }}
              ref={e => (tilesRefs.current[i] = e)}
              big
              idx={i}
              titleUpperCase
            >
              {service.description}
            </ServiceTile>
            {/* </Link> */}
          </TileContainer>
        ))}
      </TileList>
    </StyledServicesSection>
  )
}

export default ServicesSection
